import BMXModal from "../../../../Components/Modals/BMXModal/BMXModal";
import { connectModal } from "redux-modal";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import CrmReportForm from "../../Forms/CrmReportForm/CrmReportForm";

const CrmReportModal = (props) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [steps, setSteps] = useState([
    { title: t("global:crm.createReport"), error: false },
  ]);
  const [isSubmit, setIsSubmit] = useState(false);
  const formName = "CrmReportForm";
  const { handleHide, show } = props;

  const buttons = () => {};

  const setErrorHeader = (formNumber, val) => {
    steps[formNumber].error = val;
    setSteps([...steps]);
  };

  return (
    <BMXModal
      activeStep={step}
      setStep={setStep}
      open={show}
      height={"550px"}
      width={"880px"}
      onClose={handleHide}
      header={props.header}
      buttons={buttons()}
      steps={steps}
    >
      <CrmReportForm
        steps={steps}
        isSubmit={isSubmit}
        setIsSubmit={setIsSubmit}
        step={step}
        setStep={setStep}
        setErrorHeader={setErrorHeader}
        handleHide={handleHide}
        formName={formName}
        {...props}
      />
    </BMXModal>
  );
};

export default connectModal({ name: "CrmReportModal" })(CrmReportModal);
